import React, { useState, useRef, useEffect } from "react";
import useAppAccessor from "../../../../hooks/useappAccessor";
import Message from "../../constants";
import { No_Chat } from "../../../../assets/icons";
import { getBrandColor } from "../../../../utils/brand.util";
const MessageItem = ({
  messages,
  userConnect,
  memberJoin,
  memberLeft,
}: any) => {
  const messagesContainerRef = useRef<HTMLDivElement>(null);
  const [countMember, setCountMember] = useState<any>([]);
  const { getLiveMainData, getUserData } = useAppAccessor();
  const { allAttendeeList, streamState } = getLiveMainData();
  const { user, client } = getUserData();
  const { publicUserData } = user;
  const { language } = getUserData();

  const isHost = () => {
    return window.location.href.indexOf("/stream") > -1;
  };

  const isStreamStarted = streamState === "started";

  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    
  }, []);

  useEffect(() => {
    setCountMember((prevCountMembersLeft: any) => [
      ...prevCountMembersLeft,
      memberLeft,
    ]);
  }, [memberJoin]);

  const truncateFullNameCrm = (given_name: string, family_name: string) => {
    if (userConnect?.name?.match(/[a-zA-Z]+/g).length >= 4) {
      const newName = given_name + " " + family_name;
      const newdata = newName.split(" ");
      return newdata[newdata.length - 1] + " " + newdata[0];
    } else {
      return userConnect?.name;
    }
  };

  return (
    <div
      ref={messagesContainerRef}
      className="pb-20 chatbox--messages overflow-auto chatbox--messages--pd-active relative"
      style={{
        maxHeight: !isMobile ? "calc(100vh - 6rem - 76px)" : "calc(60vh)",
        overflowY: "auto",
        minHeight: !isMobile ? "calc(100vh - 6rem - 76px)" : "calc(60vh)",
        backgroundColor: "rgb(65, 65, 65)",
      }}
    >
      {messages && Array.isArray(messages) && messages.map((message: any, index: any) => {
        var attendee = allAttendeeList.find(
          (attendee: any) => attendee?.uid === message.uid
        );
        if (attendee != null)
          return (
            <>
              <div className="flex w-full px-4 py-2.5 hover:bg-[#1F1F1F]/30 transition-colors duration-150" key={index}>
                <div
                  className="rounded-full flex items-center justify-center text-white flex-shrink-0 shadow-md"
                  style={{
                    cursor:'default',
                    height: 40,
                    width: 40,
                    backgroundColor: getBrandColor(client),
                  }}
                >
                  {attendee?.avatar &&
                  attendee?.avatar.length > 0 &&
                  !attendee?.avatar.includes("default_avatar.png") ? (
                    <img
                      style={{ borderRadius: "50%", height: 40, width: 40, objectFit: "cover" }}
                      src={attendee.avatar}
                      alt={`${attendee.firstName} ${attendee.lastName}`}
                    />
                  ) : (
                    <span className="text-sm text-white font-semibold">
                    {attendee?.firstName && attendee?.lastName
                    ? `${Array.from(attendee.firstName)[0] || ""}${Array.from(
                        attendee.lastName
                      )[0] || ""}`
                    : ""}
                    </span>
                  )}
                </div>

                <div className="flex-1 ml-3 min-w-0">
                  <div className="mb-1">
                    <p className="text-white text-xs font-semibold">
                      {attendee.firstName + " " + attendee.lastName}
                    </p>
                  </div>
                  <div
                    className="inline-block rounded-lg px-3 py-2 max-w-full"
                    style={{ backgroundColor: "#2A2A2A", minWidth: "100px" }}
                  >
                    <p
                      style={{ color: "#E0DCDC", overflowWrap: "break-word" }}
                      className="text-white text-sm leading-relaxed whitespace-pre-wrap"
                    >
                      {message.text} {message.emoji}
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="text-white text-xs opacity-30 text-right mr-5">
                {message?.createAt}
              </div> */}
            </>
          );
        else {
          return (
            <>
              <div className="flex w-full px-4 py-2.5 hover:bg-[#1F1F1F]/30 transition-colors duration-150" key={index}>
                <div
                  className="rounded-full flex items-center justify-center text-white flex-shrink-0 shadow-md"
                  style={{
                    cursor:'default',
                    height: 40,
                    width: 40,
                    backgroundColor: getBrandColor(client),
                  }}
                >
                  <span className="text-sm text-white font-semibold">
                    {Array.from(message?.firstName || " ")[0] + "" + Array.from(message?.lastName || " ")[0]}
                  </span>
                </div>

                <div className="flex-1 ml-3 min-w-0">
                  <div className="mb-1">
                    <p className="text-white text-xs font-semibold">
                      {message.firstName + " " + message.lastName}
                    </p>
                  </div>
                  <div
                    className="inline-block rounded-lg px-3 py-2 max-w-full"
                    style={{ backgroundColor: "#2A2A2A", minWidth: "100px" }}
                  >
                    <p
                      style={{ color: "#E0DCDC", overflowWrap: "break-word" }}
                      className="text-white text-sm leading-relaxed whitespace-pre-wrap"
                    >
                      {message.text} {message.emoji}
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="text-white text-xs opacity-30 text-right mr-5">
                {message?.createAt}
              </div> */}
            </>
          );
        }
      })}
      {/* {messages.length === 0 && (
        <>
          {isMobile && (
            <p className="text-white text-center" style={{ opacity: 0.7 }}>
            Slide down to close.
          </p>
          )}
        </>
      )} */}

  {messages?.length === 0 && (
    <div 
      className={`absolute flex flex-col items-center justify-center px-6 py-12 ${isMobile ? '' : 'inset-0'}`}
      style={isMobile ? {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
      } : {}}
    >
      <div className="flex flex-col items-center max-w-sm">
        <div className="mb-6 p-6 bg-[#2A2A2A] rounded-2xl opacity-80">
          <img 
            src={No_Chat} 
            alt="No messages" 
            className="w-16 h-16 opacity-90"
          />
        </div>
        <h3 className="text-white text-lg font-semibold mb-2 text-center">
          {language['no_msg'] || 'No messages yet'}
        </h3>
        {isHost() && !isStreamStarted && (
          <>
            <p className="text-gray-400 text-sm text-center leading-relaxed mb-4 max-w-xs">
              {language['go_live_to_start_chatting'] || 'Go live to start chatting with your audience.'}
            </p>
            <div className="flex items-center gap-2 text-xs text-gray-500 mt-2">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
              <span>{language['messages_will_appear'] || 'Messages will appear here once the stream starts'}</span>
            </div>
          </>
        )}
        {!isHost() && (
          <p className="text-gray-400 text-sm text-center leading-relaxed max-w-xs">
            {language['no_chat_messages_yet'] || 'There are no chat messages yet'}
          </p>
        )}
      </div>
    </div>
  )}
     
    </div>
  );
};

export default MessageItem;
